var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?_c('footer',{staticClass:"brand-color text-light d-flex justify-content-center"},[_c('section',{staticClass:"layout-social py-5"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }